import React, { useState } from 'react'

// components
import {
  CRow,
  CCol,
  CFormLabel,
  CInputGroup,
  CInputGroupText,
  CFormInput
} from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import * as icon from "@coreui/icons";
import FormTextInput from '../../../general-input-form/FormTextInput'
import FormSelectInput from '../../../general-input-form/FormSelectInput'
import FormTextAreaInput from '../../../general-input-form/FormTextAreaInput'
import FormPhoneNumber from '../../../general-input-form/FormPhoneNumber'
import FormDatePicker from 'src/components/form/general-input-form/FormDatePicker';

const AppForm = ({
  values,
  errors,
  handleChange,
  handleSelectedDate,
  currencyOptions,
  countryOptions,
  provinceOptions,
  cityOptions,
  subDistrictOptions,
  industryOptions,
  phoneCountry,
  setPhoneCountry,
  setOpenFilePreview
}) => {

  return (
    <>
      <CRow className="mb-3">
        <FormTextInput
          id='store_name'
          name='store_name'
          colSize='3'
          inputLabel='Business Name'
          placeholder='Enter business name...'
          value={values.store_name}
          handleTextInput={handleChange}
          feedbackInvalid={errors.store_name}
          invalid={errors.store_name}
        />
        <FormSelectInput
          id='store_category_id'
          name='store_category_id'
          colSize='3'
          inputLabel='Business Category'
          selectOptions={industryOptions}
          value={values.store_category_id}
          handleSelectInput={handleChange}
          feedbackInvalid={errors.store_category_id}
          invalid={errors.store_category_id}
        />
        <FormDatePicker
          id='store_established_date'
          name='store_established_date'
          colSize='3'
          inputLabel='Established Since'
          placeholder='Enter business established date...'
          date={values.store_established_date}
          handleDatePicker={handleSelectedDate}
          feedbackInvalid={errors.store_established_date}
          invalid={errors.store_established_date}
        />
        <FormSelectInput
          id='store_currency_id'
          name='store_currency_id'
          colSize='3'
          inputLabel='Currency'
          selectOptions={currencyOptions}
          value={values.store_currency_id}
          handleSelectInput={handleChange}
          feedbackInvalid={errors.store_currency_id}
          invalid={errors.store_currency_id}
        />
      </CRow>
      <CRow className="mb-3">
        <FormTextInput
          id='store_person_name'
          name='store_person_name'
          colSize='4'
          inputLabel='Contact Name'
          placeholder='Enter contact name...'
          value={values.store_person_name}
          handleTextInput={handleChange}
          feedbackInvalid={errors.store_person_name}
          invalid={errors.store_person_name}
        />
        <FormTextInput
          id='store_person_email'
          name='store_person_email'
          colSize='4'
          inputLabel='Contact Email'
          placeholder='Enter contact email...'
          value={values.store_person_email}
          handleTextInput={handleChange}
          feedbackInvalid={errors.store_person_email}
          invalid={errors.store_person_email}
        />
        <CCol lg={4} >
          <CFormLabel>
            Contact Number
          </CFormLabel>
          <CInputGroup>
            {phoneCountry && phoneCountry?.id && (
              <>
                <CInputGroupText>
                  {phoneCountry?.country_code && phoneCountry?.country_code !== '' ? (
                    <CIcon icon={icon[`cif${phoneCountry?.country_code}`]} />
                  ) : (
                    phoneCountry?.name
                  )}
                </CInputGroupText>
                <CInputGroupText>
                  {phoneCountry?.phone_code}
                </CInputGroupText>
              </>
            )}
            <CFormInput
              id='store_person_number'
              name='store_person_number'
              placeholder='Enter contact number...'
              type='text'
              onChange={(e) => handleChange(e)}
              value={values.store_person_number}
              feedbackInvalid={errors.store_person_number}
              invalid={errors.store_person_number}
            />
          </CInputGroup>
        </CCol>
      </CRow>
      <CRow>
        <CFormLabel>
          Business Location:
        </CFormLabel>
      </CRow>
      <CRow className="mb-3">
        <FormTextAreaInput
          id='store_address'
          name='store_address'
          colSize='4'
          inputLabel='Address Details'
          // textDescription='Maximum description text is 300 characters'
          placeholder='Enter business address...'
          rows='5'
          value={values.store_address}
          handleTextAreaInput={handleChange}
          feedbackInvalid={errors.store_address}
          invalid={errors.store_address}
        />
        <FormSelectInput
          id='store_country_id'
          name='store_country_id'
          colSize='4'
          inputLabel='Country'
          selectOptions={countryOptions}
          value={values.store_country_id}
          handleSelectInput={handleChange}
          feedbackInvalid={errors.store_country_id}
          invalid={errors.store_country_id}
        />
        <FormTextInput
          id='store_postal_code'
          name='store_postal_code'
          colSize='4'
          inputLabel='Postal Code'
          placeholder='Enter store postal code...'
          value={values.store_postal_code}
          handleTextInput={handleChange}
          feedbackInvalid={errors.store_postal_code}
          invalid={errors.store_postal_code}
        />
      </CRow>
      <CRow className="mb-3">
        <FormSelectInput
          id='store_province_id'
          name='store_province_id'
          colSize='4'
          inputLabel='Province'
          selectOptions={provinceOptions}
          value={values.store_province_id}
          handleSelectInput={handleChange}
          feedbackInvalid={errors.store_province_id}
          invalid={errors.store_province_id}
        />
        <FormSelectInput
          id='store_city_id'
          name='store_city_id'
          colSize='4'
          inputLabel='City'
          selectOptions={cityOptions}
          value={values.store_city_id}
          handleSelectInput={handleChange}
          feedbackInvalid={errors.store_city_id}
          invalid={errors.store_city_id}
        />
        <FormSelectInput
          id='store_subdistrict_id'
          name='store_subdistrict_id'
          colSize='4'
          inputLabel='Subdistrict'
          selectOptions={subDistrictOptions}
          value={values.store_subdistrict_id}
          handleSelectInput={handleChange}
          feedbackInvalid={errors.store_subdistrict_id}
          invalid={errors.store_subdistrict_id}
        />
      </CRow>
    </>
  )
}

export default AppForm
